import { Button, Modal } from "react-bootstrap";

const SCRConfirmDialog = ({
  show,
  onHide,
  onConfirm,
  title,
  message,
  confirmLabel = "Yes, Confirm",
  cancelLabel = "Cancel",
  icon = "fa-exclamation-triangle",
  variant = "warning",
  detail,
  confirming = false,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    centered
    backdrop="static"
    className="scr-settings-confirm"
  >
    <Modal.Body>
      <div className={`scr-settings-confirm__icon scr-settings-confirm__icon--${variant}`}>
        <i className={`fas ${icon}`} aria-hidden="true" />
      </div>
      <div className="scr-settings-confirm__title">{title}</div>
      <p className="scr-settings-confirm__message mb-0">{message}</p>
      {detail ? (
        <span className="scr-settings-confirm__detail" title={detail}>
          {detail}
        </span>
      ) : null}
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide} disabled={confirming}>
        {cancelLabel}
      </Button>
      <Button
        variant="primary"
        className={`scr-settings-confirm__confirm-btn scr-settings-confirm__confirm-btn--${variant}`}
        onClick={onConfirm}
        disabled={confirming}
      >
        {confirming ? "Please wait..." : confirmLabel}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default SCRConfirmDialog;
